/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_SupplierInputs */

const en_field_supplier = /** @type {(inputs: Field_SupplierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supplier`)
};

/**
* | output |
* | --- |
* | "Supplier" |
*
* @param {Field_SupplierInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const field_supplier = /** @type {((inputs?: Field_SupplierInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_SupplierInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_field_supplier(inputs)
});